export class LanguageDropDown {
    constructor(selector) {
        this.initlialiseSelectors(selector);
        this.attachListeners();
    }

    initlialiseSelectors(selector) {
        this._element = jQuery(selector);
        this._currentLanguageElement = jQuery('.language .current-language');
        this._languageListElement = jQuery('.language-list li');
        this._languageCode = jQuery('#language_code');
        this._languageForm = jQuery('#language-form')[0];
        this.isLanguageListOpen = false;
    }

    attachListeners() {
        this.onMouseLeave();
        this.onClick();
        this.onSubmit();
    }

    toggleLanguageList() {
        this._element.fadeToggle(300);
        this.isLanguageListOpen = !this.isLanguageListOpen;
    }

    onMouseLeave() {
        this._element.on('mouseleave', () => {
            this.isLanguageListOpen ? this.toggleLanguageList() : '';
        });
    }

    onClick() {
        this._currentLanguageElement.on('click', () => {
            this.toggleLanguageList();
        });
    }

    onSubmit() {
        this._languageListElement.on('click', event => {
            event.stopPropagation();
            event.preventDefault();
            const selectedLanguage = event.target.getAttribute('data-lang');
            var currentUrl = new URL(window.location.href.toString());
            var pathname = currentUrl.pathname.replace(/en|fr|es|pt|de/gi, selectedLanguage);
            window.location = currentUrl.origin + pathname
            // this._languageCode.val(selectedLanguage);
            // this._languageForm.submit();
        });
    }

    static setup(selector) {
        new LanguageDropDown(selector);
    }
}
